module.exports = __webpack_public_path__ + "03_mole.f0d7f120.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer2/03_mole.png
// module id = eDG4
// module chunks = 0